import * as React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { getPost } from "@/lib/blog/getPost";
import { BlogDetail } from "@/components/BlogDetail";
import { seo } from "@/utilities/seo";

export const Route = createFileRoute("/_home/blog/$slug/")({
  loader: async ({ params }) => {
    const post = await getPost({ data: { slug: params.slug } });
    return { post };
  },
  errorComponent: ({ error }) => {
    if (error instanceof Error && error.message === "NOT_FOUND") {
      return <div>Post not found!</div>;
    }
    return <div>An error occurred loading the post.</div>;
  },
  head: (ctx) => {
    const post = ctx.loaderData.post;

    // Calculate estimated reading time based on content length
    const wordCount = post.contentHtml.replace(/<[^>]*>/g, "").split(/\s+/).length;
    const readingTime = `${Math.ceil(wordCount / 200)} min read`;

    return {
      meta: seo({
        title: post.title,
        description: post.summary,
        image: post.image.startsWith("/") ? `https://progressmade.ai${post.image}` : post.image,
        keywords: post.keywords.join(", "),
        canonical: `https://progressmade.ai/blog/${post.slug}`,
        type: "article",
        author: "ProgressMade.ai",
        published: post.date.toISOString(),
        readingTime,
      }),
    };
  },
  component: BlogDetailPage,
});

function BlogDetailPage() {
  const { post } = Route.useLoaderData();
  return <BlogDetail post={post} />;
}
